import { Banner, ModalBody, ModalFoot } from '@dixa/lib-shared-habla';

import { EndpointMessengersDisplay } from '../../../../../../components';
import { EndpointMessengers } from '../../../../../../customForms.types';

type Props = {
  endpointMessengers: EndpointMessengers;
  hide: () => void;
};

export function CannotDeleteFormEndpoint({
  endpointMessengers,
  hide,
}: Props): JSX.Element {
  return (
    <>
      <ModalBody>
        <Banner
          variant="fail"
          headline={`Can not delete endpoint`}
          description={
            <EndpointMessengersDisplay
              endpointMessengers={endpointMessengers}
              onLinkClick={hide}
            />
          }
        />
      </ModalBody>

      <ModalFoot cancelOnClick={hide} />
    </>
  );
}
